// Global Instructions Rule Applied!
//
// cfg.pipeline_deal_type_exclusions as it arrives in globalConfigs: the deal
// types barred from a pipeline kind. pipeline_type_id is a cfg.pipeline_types
// id (20261111120100) — it was the lookup LABEL, matched case-insensitively in
// SQL, in the Python creation flow and here, so renaming the type in the admin
// UI silently un-excluded every deal type at once.
//
// Consumed by the New Deal drawer to hide the Pipeline Stage field for an
// excluded deal type. Managed in Configuration → Deal Origination.
import { z } from 'zod'

export const PipelineDealTypeExclusionModelSchema = z
  .object({
    id: z.string(),
    pipeline_type_id: z.string(),
    deal_type_id: z.string()
  })
  .strict()

export type PipelineDealTypeExclusionModel = z.infer<typeof PipelineDealTypeExclusionModelSchema>
